<div class="container-fluid">

  <!-- Title Section -->
  <div class="row mb-4">
    <div class="col-12">
      <h4 id="upper">Niveaux d'exécution physique du pta par service</h4>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="row mb-3">
    <div class="col-lg-12 d-flex justify-content-end align-items-center flex-wrap gap-3">
      <div class="d-flex align-items-center">
        <label class="me-2 fw-bold text-secondary">Début:</label>
        <input type="date" class="form-control" style="width: 180px;" [(ngModel)]="dateDebut" name="dateDebut">
      </div>

      <div class="d-flex align-items-center">
        <label class="me-2 fw-bold text-secondary">Fin:</label>
        <input type="date" class="form-control" style="width: 180px;" [(ngModel)]="dateFin" name="dateFin">
      </div>

      <div class="me-3">
          <div id="tickets-table_filter" class="dataTables_filter">
            <button (click)="getStatistique()" type="button" class="btn btn-primary"><i class="pi pi-search" style="font-size: 0.8rem"></i> Rechercher</button>
          </div>
        </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
          aria-haspopup="true" aria-expanded="false">
          Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format Excel</a>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
                <tr>
                  <th>Service</th>
                  <th class="text-center">Tep Prévu (%)</th>
                  <th class="text-center">Tep Réalisé (%)</th>
                  <th class="text-center">Ecart</th>
                  <th class="text-center" style="width: 80px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedProjets; let index = index">
                  <td>{{item.service?.libelle}}</td>
                  <td class="text-center">{{item.tep_prevu}}</td>
                  <td class="text-center">{{item.tep_realise}}</td>
                  <td class="text-center">{{(item.tep_realise || 0) - (item.tep_prevu || 0) | number:'1.2-2'}}</td>
                  <td class="text-center">
                    <a (click)="openModalActivitesService(item)" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="détails">
                      <i class="pi pi-eye font-size-18"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="paginatedProjets.length === 0">
                  <td colspan="7" class="text-center text-muted py-4">
                    Aucune donnée disponible
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Loading Indicator -->
          <div class="d-flex justify-content-center mt-3" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div class="mt-3">
            <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
              [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
            </p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for details -->
<p-dialog [(visible)]="displayModal" header="TEP Activités de {{ serviceLibelle }} ({{ptaItems.length}})" [modal]="true" [style]="{ width: '80vw' }" [closable]="true" (onHide)="closeModal()">
    <div class="p-fluid">

      <!-- Loading Indicator for Modal -->
      <div class="d-flex justify-content-center align-items-center my-5" *ngIf="isLoadingModal === true">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor" class="mb-3">Chargement des données en cours...</h5>
              <div class="loader4"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Content (hidden while loading) -->
      <div *ngIf="!isLoadingModal">
        <div  class="mb-5">
     
      <div  class="mb-5">

        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="table-secondary">
              <tr>
                <th>Code</th>
                <th>Libellé</th>
                <th>TEP Prévu</th>
                <th>TEP Réalisé</th>
                <th>Ecart</th>
                <th style="width: 80px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let act of paginatedProjets1">
                <td>{{ act.activite.code_activite }}</td>
                <td>{{ act.activite.activite }}</td>
                <td>{{ act.tep_prevu }}</td>
                <td>{{ act.tep_realise }}</td>
                <td class="text-en">{{ (act.tep_realise - act.tep_prevu) }}%</td>
                <td class="text-center">
                  <a (click)="openModalTachesByService(act)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover title="détail tâches">
                    <i class="pi pi-eye font-size-18"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-3">
        <p-paginator (onPageChange)="onPageChangeProjets1($event)" [first]="firstProjets1" [rows]="rowsProjets1"
          [totalRecords]="totalRecords1" [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
      </div>
      </div>
    </div>
  </p-dialog>

<!-- Modal détails des tâches par activité (Service) -->
<p-dialog [(visible)]="displayModalTaches" header="Tâches de {{ activiteLibelle }} ({{tacheItems.length}})" [modal]="true"
  [style]="{ width: '80vw' }" [closable]="true" (onHide)="closeModalTaches()">
  <div class="p-fluid">
    <div class="d-flex justify-content-center align-items-center my-5" *ngIf="isLoadingModalTaches === true">
      <div class="container">
        <div class="row">
          <div class="text-center">
            <h5 id="graycolor" class="mb-3">Chargement des données en cours...</h5>
            <div class="loader4"></div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isLoadingModalTaches">
      <div class="mb-5">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="table-secondary">
              <tr>
                <th>Code</th>
                <th>Libellé</th>
                <th>Poids</th>
                <th>TEP Prévu</th>
                <th>TEP Réalisé</th>
                <th>Ecart</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tache of paginatedTaches">
                <td>{{ tache.code }}</td>
                <td>{{ tache.libelle }}</td>
                <td>{{ tache.poids }}</td>
                <td>{{ tache.tep_prevu }}</td>
                <td>{{ tache.tep_realise }}</td>
                <td class="text-end">{{ (tache.tep_realise - tache.tep_prevu) | number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="tacheItems.length === 0" class="text-center p-4">
        <p class="text-muted">Aucune donnée disponible</p>
      </div>
      <div class="mt-3">
        <p-paginator *ngIf="totalRecordsTaches > 0" (onPageChange)="onPageChangeTaches($event)" [first]="firstTaches"
          [rows]="rowsTaches" [totalRecords]="totalRecordsTaches" [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>
</p-dialog>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
